<template>
  <div class="home-section-wrap-landing">
    <section class="home-section-landing" style="display: block !important;" id="home-section-landing">
      <div class="container">
        <h1 class="module-title">
          <span v-if="this.current_act.type < 5">Редактирование акта выполненных работ и услуг </span>
          <span v-else>Редактирование консолидированного счета </span>
          <a class="custom-link" :href="'/acts/' + this.current_act.id">
            ID{{ this.current_act.id }}
          </a>
        </h1>
        <div class="wrapper">
          <div :class="get_arrow_steps_class() + ' clearfix'">
            <div v-for="(step_i, index) in this.all_steps" :key="index + 1"
                 :class="'step ' + curr_class(index + 1)">
              <span>Шаг {{ index + 1 }} ({{ step_i.name }})</span>
            </div>
          </div>
          <div :class="prev_next_btn_class()" style="height: 30px; margin-top: 2rem; display: flex">
            <a v-if="this.curr_module !== 1" @click="prevStep()">
              <button class="btn-success btn-blue-success" style="width: 200px; padding: .5rem; border-radius: .5rem">
                Вернуться
              </button>
            </a>
            <a v-if="all_required_exist" @click="nextStep()">
              <button class="btn-success" style="width: 200px; padding: .5rem; border-radius: .5rem">
                <span v-if="this.current_act.type !== 2 && this.curr_module === 3">Сохранить</span>
                <span v-else-if="this.curr_module === 5">Сохранить</span>
                <span v-else>Продолжить</span>
              </button>
            </a>
          </div>
        </div>
        <div class="aiia-wizard-step" style="width: 100%; margin-bottom: 30px">
          <div>
            <h2>
              <span class="circle-number">{{ curr_module }}</span>
              Инструкция
              <span style="color: #23468c">({{ this.all_steps[curr_module - 1].name }})</span>
            </h2>
            <div class="step-content">
              <p v-if="this.current_act.type < 5">
                {{ this.all_steps[curr_module - 1].instruction }}
              </p>
              <p v-else>
                {{ this.all_steps[curr_module - 1].instruction_ks }}
              </p>
            </div>
          </div>
        </div>
        <div class="categories-container">
          <div v-show="this.curr_module === 1" class="flex-start-column gap-2r">
            <div class="flex-space-between gap-1r">
              <div class="flex-start-column div-half gap-half">
                <label v-if="this.current_act.type < 5">Номер акта</label>
                <label v-else>Номер КС</label>
                <input v-if="this.current_act.type < 5" class="input-act-params" placeholder="Введите номер акта*" v-model="current_act.number">
                <input v-else class="input-act-params" placeholder="Введите номер КС*" v-model="current_act.number">
              </div>
              <div class="flex-start-column div-full gap-half">
                <label v-if="this.current_act.type < 5">Наименование акта</label>
                <label v-else>Период</label>
                <input v-if="this.current_act.type < 5" class="input-act-params" placeholder="Введите наименование акта*" v-model="current_act.name">
                <input v-else class="input-act-params" placeholder="Введите период (Формат: dd.mm.yyyy-dd.mm.yyyy)*" v-model="current_act.name">
              </div>
              <div class="flex-start-column div-half gap-half">
                <label v-if="this.current_act.type < 5">Дата акта</label>
                <label v-else>Дата КС</label>
                <input v-if="this.current_act.type < 5"
                       class="input-act-params"
                       type="date"
                       placeholder="Введите дату акта*"
                       v-model="current_act.act_date">
                <input v-else
                       class="input-act-params"
                       type="date"
                       placeholder="Введите дату КС*"
                       v-model="current_act.act_date">
              </div>
            </div>
            <div class="flex-space-between gap-1r">
              <div class="flex-start-column div-full gap-half">
                <label>Договор</label>
                <select class="input-act-params" v-model="current_act.contract.id">
                  <option value="">Выберите договор оказания работ / услуг*</option>
                  <option v-for="(contract, index) in this.contracts" :key="index" :title="contract.name"
                          :value="contract.id">
                    ({{ contract.date_from | ddmmyyyy }}) №{{ contract.number }} {{ contract.short_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex-space-between gap-1r" v-if="current_act.type === 2">
              <div class="flex-start-column div-full gap-half">
                <label>Наименование стройки</label>
                <input class="input-act-params" placeholder="Введите наименование стройки*" v-model="current_act.object_name">
              </div>
              <div class="flex-start-column div-half gap-half">
                <label>Месяц услуг</label>
                <select class="input-act-params" v-model="current_act.act_month">
                  <option value="">Выберите месяц услуг</option>
                  <option v-for="(month, index) in this.months_list" :key="index" :value="month">{{ month }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-show="this.curr_module === 2" class="flex-start-column gap-2r">
            <h3 class="text-center">Текущие файлы</h3>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-nowrap scrl-x">
                  <thead class="thead-light">
                  <tr>
                    <th scope="col" class="">№ п/п</th>
                    <th scope="col" class="">Наименование</th>
                    <th scope="col" class="">Файл(-ы)</th>
                    <th scope="col" class="">Тип файла</th>
                    <th scope="col" class="">Расширения</th>
                    <th scope="col" class="">Удалить</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(add_file, index) in this.current_act.additional_files" :key="add_file.id"
                      :id="'req-tr-' + add_file.id" :class="'tr-main ' + getLineThroughClass(add_file.to_remove)">
                    <td data-label="" class="">
                      {{ index + 1 }}
                    </td>
                    <td data-label="" class="">
                      {{ add_file.name }}
                    </td>
                    <td data-label="" class="">
                      <a class="custom-link" target="_blank" :href="add_file.file">
                        Открыть файл
                      </a>
                    </td>
                    <td data-label="" class="">
                      Доп. файл
                    </td>
                    <td data-label="" class="">
                      {{ add_file.extension }}
                    </td>
                    <td data-label="" class="">
                      <input type="checkbox" v-model="add_file.to_remove"
                             style="width: 1rem; height: 1rem; margin-left: 1rem">
                    </td>

                  </tr>
                  <tr v-for="(double_im, index) in this.current_act.before_after_images" :key="double_im.id"
                      :id="'req-tr-d-' + double_im.id" :class="'tr-main ' + getLineThroughClass(double_im.to_remove)">
                    <td data-label="" class="">
                      {{ index + 1 + current_act.additional_files.length }}
                    </td>
                    <td data-label="" class="">
                      Изображения до-после №{{ index + 1 }}
                    </td>
                    <td data-label="" class="">
                      <a class="custom-link" @click="showDoubleImageModal(double_im.id)">
                        Просмотр изображений
                      </a>
                      <modal :name="'double-modal-' + double_im.id" :height="900" :width="1000">
                        <div class="modal-inner"
                             style="height: inherit; width: inherit; text-align: left; overflow: auto">
                          <h3 class="modal-title" style="padding-bottom: 0">Изображение до-после №{{ index + 1 }}</h3>
                          <div class="modal-info"
                               style="width: auto; height: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column">
                            <img-comparison-slider>
                              <img slot="before" :src="double_im.file_fst"
                                   style="width: auto; height: auto; object-fit: contain !important;"/>
                              <img slot="after" :src="double_im.file_snd"
                                   style="width: 100%; height: auto; object-fit: contain !important;"/>
                            </img-comparison-slider>
                          </div>
                        </div>
                      </modal>
                    </td>
                    <td data-label="" class="">
                      Двойное изображение
                    </td>
                    <td data-label="" class="">
                      {{ double_im.file_fst.split('.')[double_im.file_fst.split('.').length - 1].toUpperCase() }},
                      {{ double_im.file_snd.split('.')[double_im.file_snd.split('.').length - 1].toUpperCase() }}
                    </td>
                    <td data-label="" class="">
                      <input type="checkbox" v-model="double_im.to_remove"
                             style="width: 1rem; height: 1rem; margin-left: 1rem">
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <h3 class="text-center">Новые файлы</h3>
            <div class="dropzone">
              <input type="file" class="input-field" id="input-field-multiple" ref="files_additional" multiple
                     accept=".pdf, image/png, image/jpeg, .xls, .xlsx" @change="reuploadVl1"/>
              <div v-if="!current_act.uploading" class="call-to-action">
                Перетащите файлы сюда или нажмите, чтобы загрузить
                <p>
                  <small>максимальный размер файлов: 5MB</small><br>
                  <small>максимальный размер всех файлов: не больше 100 мб</small>
                </p>
                <p>
                  <small>типы загружаемых файлов: .pdf, .png, .jpeg, .xls, .xlsx</small>
                </p>
              </div>
              <div v-if="current_act.uploading" class="uploaded-msg">
                Файлы успешно загружены
              </div>
            </div>
            <modal name="file-modal-multiple">
              <div class="modal-inner">
                <div>Следует загружать следующие типы файлов: pdf, png, jpg, xls, xlsx</div>
                <button @click="closeModalMultuple">Понятно</button>
              </div>
            </modal>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem"
                 v-for="(double_file, index) in this.double_files" :key="index">
              <div class="dropzone">
                <input type="file" class="input-field" :id="'input-field-d1-' + index" :ref="'file_d1_' + index"
                       accept="image/png, image/jpeg" @change="reuploadVl_d1(index)"/>
                <div v-if="!double_file.uploading_d1" class="call-to-action">
                  Перетащите фото сюда или нажмите, чтобы загрузить фото ДО ({{ index + 1 }})
                  <p>
                    <small>максимальный размер файла: 5MB</small>
                  </p>
                  <p>
                    <small>типы загружаемого файла: .png, .jpeg</small>
                  </p>
                </div>
                <div v-if="double_file.uploading_d1" class="uploaded-msg">
                  Файл ДО ({{ index + 1 }}) успешно загружен
                </div>
                <modal :name="'file-modal-d1-' + index">
                  <div class="modal-inner">
                    <div>Следует загружать следующие типы файлов: png, jpg</div>
                    <button @click="closeModalD1(index)">Понятно</button>
                  </div>
                </modal>
              </div>
              <div class="dropzone">
                <input type="file" class="input-field" :id="'input-field-d2-' + index" :ref="'file_d2_' + index"
                       accept="image/png, image/jpeg" @change="reuploadVl_d2(index)"/>
                <div v-if="!double_file.uploading_d2" class="call-to-action">
                  Перетащите фото сюда или нажмите, чтобы загрузить фото ПОСЛЕ ({{ index + 1 }})
                  <p>
                    <small>максимальный размер файла: 5MB</small>
                  </p>
                  <p>
                    <small>типы загружаемого файла: .png, .jpeg</small>
                  </p>
                </div>
                <div v-if="double_file.uploading_d2" class="uploaded-msg">
                  Файл ПОСЛЕ ({{ index + 1 }}) успешно загружен
                </div>
                <modal :name="'file-modal-d2-' + index">
                  <div class="modal-inner">
                    <div>Следует загружать следующие типы файлов: png, jpg</div>
                    <button @click="closeModalD2(index)">Понятно</button>
                  </div>
                </modal>
              </div>
            </div>
            <button @click="add_double_file" class="add_double_file">Добавить фото до/после</button>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 1" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price">
              <tr>
                <th rowspan="2" style="width: 4%">Номер по порядку</th>
                <th rowspan="2" style="width: 29%">Наименование работ (услуг) (в разрезе их подвидов в соответствии с
                  технической спецификацией, заданием, графиком выполнения работ (услуг) при их наличии)
                </th>
                <th rowspan="2" style="width: 22%">Дата выполнения работ (оказания услуг)**</th>
                <th rowspan="2" style="width: 7%">Сведения об отчете о научных исследованиях, маркетинговых,
                  консультационных и прочих услугах (дата, номер, количество страниц) (при их наличии)***
                </th>
                <th rowspan="2" style="width: 6%">Единица измерения</th>
                <th colspan="3" style="width: 32%" rowspan="1">Выполнено работ (оказано услуг)</th>
              </tr>
              <tr>
                <th>Количество</th>
                <th>Цена за единицу</th>
                <th>Стоимость (в тенге)</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i">{{ i }}</td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i">
                  <input v-if="i === 2" class="m-input-cell" type="text" style="background: white"
                         v-model="current_act.global_work"/>
                </td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index" :class="{'header-row': row.is_header}">
                <td>
                  {{ row.is_header ? '' : row_display_number(index) }}
                  <button @click="rm_row_index(index)" type="button" class="rm_row_btn_small"
                          :title="row.is_header ? 'Убрать заголовок' : 'Убрать строку'">-</button>
                </td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"
                         :class="{'header-name': row.is_header}"
                         :placeholder="row.is_header ? 'Наименование заголовка (группы строк)' : ''"
                         :title="row.is_header ? 'Заголовок группы строк: без номера и цены, количество и стоимость — по строкам ниже' : ''"/>
                </td>
                <td v-if="row.is_header"></td>
                <td v-else-if="row.double_date">
                  <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; float: left; font-size: xx-small"/>
                  <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; border-left: 1px solid gray; float: right; font-size: xx-small"/>
                </td>
                <td v-else>
                  <input v-model="row.row_date" class="m-input-cell required-cell" type="date"/>
                </td>
                <td><input v-if="!row.is_header" v-model="row.research_report" class="m-input-cell"/></td>
                <td><input v-if="!row.is_header" v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                <td>
                  <input v-if="!row.is_header" v-model="row.count" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                  <input v-else-if="manual_totals" v-model="row.count" min="0" class="m-input-cell"
                         :class="{'calc-mismatch': header_count_mismatch(row)}"
                         :title="header_count_mismatch(row) ? 'Не сходится с расчётом: сумма количеств строк = ' + prettyPrice(header_expected(row).count) : 'Количество по заголовку, ручной ввод'"
                         v-on:change="manual_header_count_changed(row)"/>
                  <span v-else class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(row.count) }}
                  </span>
                </td>
                <td>
                  <input v-if="!row.is_header" v-model="row.unit_price" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <input v-if="manual_totals" v-model="row.total" min="0" class="m-input-cell"
                         :class="{'calc-mismatch': row_mismatch(row)}"
                         :title="row_mismatch(row) ? 'Не сходится с расчётом: ' + (row.is_header ? 'сумма стоимостей строк = ' : 'количество × цена = ') + prettyPrice(row_expected_total(row)) : 'Стоимость (в тенге), ручной ввод'"
                         v-on:change="manual_row_total_changed(row)"/>
                  <span v-else class="m-input-cell" style="background: inherit">
                    {{ row.is_header ? prettyPrice(row.total) : prettyPrice(row.count * row.unit_price) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="8">
                  <button @click="showAddRowModal" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                  <modal name="add-row-modal" :height="330">
                    <h3 class="modal-title" style="padding: 1rem">Добавление строки акта</h3>
                    <div class="modal-inner-short" style="text-align: left; width: 100%">
                      <div class="modal-info" style="width: inherit">
                        <select class="input-field-default" id="row-kind" v-model="row_kind"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                title="Строка — обычная строка акта. Заголовок — группа строк: без номера и цены, количество и стоимость считаются по строкам ниже него">
                          <option value="row">Строка акта</option>
                          <option value="header">Заголовок (группа строк)</option>
                        </select>
                        <select v-if="row_kind === 'row'" class="input-field-default" id="row-date-type"
                                style="margin-left: 15%; margin-right: 15%; width: 70%; margin-top: 0.5rem"
                                v-on:change="change_row_date_type()">
                          <option value="" selected>Выберите тип даты строки*</option>
                          <option value="2">Период оказания работ / услуг</option>
                          <option value="1">Дата оказания работ / услуг</option>
                        </select>
                        <p v-else style="margin: 0.5rem 15% 0 15%; font-size: small">
                          У заголовка заполняется только наименование. Количество и стоимость заголовка
                          считаются по строкам ниже него до следующего заголовка; нумерация строк сквозная.
                        </p>
                      </div>
                      <div style="position: absolute; bottom: 0; width: 100%; padding: 1rem">
                        <button class="btn-success input-field-default" style="border-radius: 5px;" type="button"
                                v-if="row_kind === 'header' || this.row_date_type !== ''" @click="add_row">
                          {{ row_kind === 'header' ? 'Добавить заголовок' : 'Добавить строку' }}
                        </button>
                      </div>
                    </div>
                  </modal>
                </td>
              </tr>
              <tr v-if="manual_totals">
                <td colspan="8" style="text-align: left; font-size: small; padding: 4px 8px">
                  По договору включён ручной ввод сумм: «Стоимость (в тенге)» по строкам, «Итого», «Сумма НДС» и «Всего»
                  можно править вручную, введённые значения сохраняются как есть. При расхождении с расчётом
                  (количество × цена) строка подсвечивается — это только предупреждение, сохранение не блокируется.
                  <button type="button" class="upload-from-xls" style="margin-left: 1rem"
                          @click="recalc_totals_from_rows" title="Заполнить суммы по строкам акта">
                    Пересчитать по строкам
                  </button>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Итого:</span>
                  <input v-if="i === 8 && manual_totals" v-model="current_act.total" min="0" class="m-input-cell"
                         v-on:change="manual_totals_changed('total')"/>
                  <span v-else-if="i === 8" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Сумма НДС:</span>
                  <input v-if="i === 8 && manual_totals" v-model="current_act.nds" min="0" class="m-input-cell"
                         v-on:change="manual_totals_changed('nds')"/>
                  <input v-else-if="i === 8" v-model="current_act.nds" min="0" class="m-input-cell"
                         v-on:change="auto_calc(true)"/>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Всего:</span>
                  <input v-if="i === 8 && manual_totals" v-model="current_act.total_with_nds" min="0" class="m-input-cell"
                         v-on:change="manual_totals_changed('total_with_nds')"/>
                  <span v-else-if="i === 8" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total_with_nds) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th colspan="8" rowspan="3"
                    style="text-align: center; font-size: small; padding-top: 0; padding-bottom: 0">
                  <p>*Применяется для приемки-передачи выполненных работ (оказанных услуг), за исключением
                    строительно-монтажных работ.</p>
                  <p>**Заполняется в случае, если даты выполненных работ (оказанных услуг) приходятся на различные
                    периоды, а также в случае, если даты выполнения работ (оказания услуг) и даты подписания (принятия)
                    работ (услуг) различны.</p>
                  <p>***Заполняется в случае наличия отчета о научных исследованиях, маркетинговых, консультационных и
                    прочих услугах.</p>
                </th>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 4" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price">
              <tr>
                <th rowspan="2" style="width: 4%">Номер по порядку</th>
                <th rowspan="2" style="width: 7%">ИИН</th>
                <th rowspan="2" style="width: 10%">ФИО работника</th>
                <th rowspan="2" style="width: 19%">Наименование работ (услуг) (в разрезе их подвидов в соответствии с
                  технической спецификацией, заданием, графиком выполнения работ (услуг) при их наличии)
                </th>
                <th rowspan="2" style="width: 22%">Дата выполнения работ (оказания услуг)**</th>
                <th rowspan="2" style="width: 7%">Сведения об отчете о научных исследованиях, маркетинговых,
                  консультационных и прочих услугах (дата, номер, количество страниц) (при их наличии)***
                </th>
                <th rowspan="2" style="width: 6%">Единица измерения</th>
                <th colspan="3" style="width: 26%" rowspan="1">Выполнено работ (оказано услуг)</th>
              </tr>
              <tr>
                <th>Количество</th>
                <th>Цена за единицу</th>
                <th>Стоимость (в тенге)</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-model="row.iin" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.fio" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"/>
                </td>
                <td v-if="row.double_date">
                  <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; float: left; font-size: xx-small"/>
                  <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; border-left: 1px solid gray; float: right; font-size: xx-small"/>
                </td>
                <td v-else>
                  <input v-model="row.row_date" class="m-input-cell required-cell" type="date"/>
                </td>
                <td><input v-model="row.research_report" class="m-input-cell"/></td>
                <td><input v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                <td>
                  <input v-model="row.count" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <input v-model="row.unit_price" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <span class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(row.count * row.unit_price) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="10">
                  <button @click="showAddRowModal" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                  <modal name="add-row-modal" :height="250">
                    <h3 class="modal-title" style="padding: 1rem">Выберите тип даты строки акта</h3>
                    <div class="modal-inner-short" style="text-align: left; width: 100%">
                      <div class="modal-info" style="width: inherit">
                        <select class="input-field-default" id="row-date-type-4"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                v-on:change="change_row_date_type_4()">
                          <option value="" selected>Выберите тип даты строки*</option>
                          <option value="2">Период оказания работ / услуг</option>
                          <option value="1">Дата оказания работ / услуг</option>
                        </select>
                      </div>
                      <div style="position: absolute; bottom: 0; width: 100%; padding: 1rem">
                        <button class="btn-success input-field-default" style="border-radius: 5px;" type="button"
                                v-if="this.row_date_type !== ''" @click="add_row">Добавить строку
                        </button>
                      </div>
                    </div>
                  </modal>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Итого:</span>
                  <span v-if="i === 10" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Сумма НДС:</span>
                  <input v-if="i === 10" v-model="current_act.nds" min="0" class="m-input-cell"
                         v-on:change="auto_calc(true)"/>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Всего:</span>
                  <span v-if="i === 10" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total_with_nds) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th colspan="10" rowspan="3"
                    style="text-align: center; font-size: small; padding-top: 0; padding-bottom: 0">
                  <p>*Применяется для приемки-передачи выполненных работ (оказанных услуг), за исключением
                    строительно-монтажных работ.</p>
                  <p>**Заполняется в случае, если даты выполненных работ (оказанных услуг) приходятся на различные
                    периоды, а также в случае, если даты выполнения работ (оказания услуг) и даты подписания (принятия)
                    работ (услуг) различны.</p>
                  <p>***Заполняется в случае наличия отчета о научных исследованиях, маркетинговых, консультационных и
                    прочих услугах.</p>
                </th>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 5" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price">
              <tr>
                <th style="width: 4%">№П/П</th>
                <th style="width: 16.5%">Услуга</th>
                <th style="width: 14.5%">Пассажир</th>
                <th style="width: 14.5%">ИИН</th>
                <th style="width: 14.5%">Номер бланка</th>
                <th style="width: 14.5%">Подразделение</th>
                <th style="width: 14.5%">Маршрут</th>
                <th style="width: 14.5%">Тариф</th>
                <th style="width: 14.5%">Дата начала</th>
                <th style="width: 14.5%">Дата окончания</th>
                <th style="width: 14.5%">Количество</th>
                <th style="width: 14.5%">Штраф</th>
                <th style="width: 14.5%">Сервисные сборы</th>
                <th style="width: 14.5%">НДС сервисных сборов</th>
                <th style="width: 14.5%">Сумма</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" :key="i">{{ i }}</td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" :key="i">
                  <input v-if="i === 2" class="m-input-cell" type="text" style="background: white"
                         v-model="current_act.global_work"/>
                </td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.fio" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.iin" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.blank_number" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.podrazdelenie" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.marshrut" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.unit_price" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                  />
                </td>
                <td>
                  <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                  />
                </td>
                <td>
                  <input v-model="row.count" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.penalty" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.total_service" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.nds_service" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.total" min="0" type="number" class="m-input-cell"/>
                </td>
              </tr>
              <tr>
                <td colspan="15">
                  <button @click="row_date_type = 2; add_row() " type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Итого:</span>
                  <span v-if="i === 15" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 6" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price">
              <tr>
                <th style="width: 4%">№П/П</th>
                <th style="width: 16.5%">Документ/Операция</th>
                <th style="width: 14.5%">Пассажир</th>
                <th style="width: 14.5%">ИИН</th>
                <th style="width: 14.5%">Номер бланка</th>
                <th style="width: 14.5%">Подразделение</th>
                <th style="width: 14.5%">Маршрут</th>
                <th style="width: 14.5%">Тариф</th>
                <th style="width: 14.5%">Такса</th>
                <th style="width: 14.5%">Дата вылета</th>
                <th style="width: 14.5%">Дата прилета</th>
                <th style="width: 14.5%">Тариф использованного участка</th>
                <th style="width: 14.5%">Штраф</th>
                <th style="width: 14.5%">Сервисные сборы</th>
                <th style="width: 14.5%">НДС сервисных сборов</th>
                <th style="width: 14.5%">Сумма</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]" :key="i">{{ i }}</td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]" :key="i">
                  <input v-if="i === 2" class="m-input-cell" type="text" style="background: white"
                         v-model="current_act.global_work"/>
                </td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.fio" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.iin" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.blank_number" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.podrazdelenie" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.marshrut" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.unit_price" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.taksa" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                  />
                </td>
                <td>
                  <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                  />
                </td>
                <td>
                  <input v-model="row.count" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.penalty" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.total_service" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.nds_service" min="0" type="number" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.total" min="0" type="number" class="m-input-cell"/>
                </td>
              </tr>
              <tr>
                <td colspan="16">
                  <button @click="row_date_type = 2; add_row() " type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Итого:</span>
                  <span v-if="i === 16" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 3" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price3">
              <tr>
                <th rowspan="3" style="width: 4%">Номер по порядку</th>
                <th rowspan="3" style="width: 26%">Наименование работ (услуг) (в разрезе их подвидов в соответствии с
                  технической спецификацией, заданием, графиком выполнения работ (услуг) при их наличии)
                </th>
                <th rowspan="3" style="width: 22%">Дата выполнения работ (оказания услуг)**</th>
                <th rowspan="3" style="width: 6%">Сведения об отчете о научных исследованиях, маркетинговых,
                  консультационных и прочих услугах (дата, номер, количество страниц) (при их наличии)***
                </th>
                <th rowspan="3" style="width: 5%">Единица измерения</th>
                <th colspan="5" style="width: 36%" rowspan="1">Выполнено работ (оказано услуг)</th>
              </tr>
              <tr>
                <th rowspan="2">количество</th>
                <th rowspan="2">цена за единицу</th>
                <th rowspan="1" colspan="2">снижение стоимости</th>
                <th rowspan="2">стоимость</th>
              </tr>
              <tr>
                <th>основание*</th>
                <th>сумма снижения, тенге</th>
              </tr>

              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i">{{ i }}</td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i">
                  <input v-if="i === 2" class="m-input-cell" type="text" style="background: white"
                         v-model="current_act.global_work"/>
                </td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"/>
                </td>
                <td v-if="row.double_date">
                  <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; float: left; font-size: xx-small"/>
                  <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                         style="width: 50%; border-left: 1px solid gray; float: right; font-size: xx-small"/>
                </td>
                <td v-else>
                  <input v-model="row.row_date" class="m-input-cell required-cell" type="date"/>
                </td>
                <td><input v-model="row.research_report" class="m-input-cell"/></td>
                <td><input v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                <td>
                  <input v-model="row.count" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <input v-model="row.unit_price" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <input v-model="row.reason" class="m-input-cell"/>
                </td>
                <td>
                  <input v-model="row.reason_cost" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <span class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(row.count * row.unit_price - row.reason_cost) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="10">
                  <button @click="showAddRowModal" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                  <modal name="add-row-modal" :height="250">
                    <h3 class="modal-title" style="padding: 1rem">Выберите тип даты строки акта</h3>
                    <div class="modal-inner-short" style="text-align: left; width: 100%">
                      <div class="modal-info" style="width: inherit">
                        <select class="input-field-default" id="row-date-type"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                v-on:change="change_row_date_type()">
                          <option value="" selected>Выберите тип даты строки*</option>
                          <option value="2">Период оказания работ / услуг</option>
                          <option value="1">Дата оказания работ / услуг</option>
                        </select>
                      </div>
                      <div style="position: absolute; bottom: 0; width: 100%; padding: 1rem">
                        <button class="btn-success input-field-default" style="border-radius: 5px;" type="button"
                                v-if="this.row_date_type !== ''" @click="add_row">Добавить строку
                        </button>
                      </div>
                    </div>
                  </modal>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Итого:</span>
                  <span v-if="i === 10" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Сумма НДС:</span>
                  <input v-if="i === 10" v-model="current_act.nds" min="0" class="m-input-cell" v-on:change="auto_calc(true)"/>
                </td>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i" style="height: 35px">
                  <span v-if="i === 2">Всего:</span>
                  <span v-if="i === 10" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total_with_nds) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th colspan="10" rowspan="3"
                    style="text-align: center; font-size: small; padding-top: 0; padding-bottom: 0">
                  <p>*Применяется для приемки-передачи выполненных работ (оказанных услуг), за исключением
                    строительно-монтажных работ.</p>
                  <p>**Заполняется в случае, если даты выполненных работ (оказанных услуг) приходятся на различные
                    периоды, а также в случае, если даты выполнения работ (оказания услуг) и даты подписания (принятия)
                    работ (услуг) различны.</p>
                  <p>***Заполняется в случае наличия отчета о научных исследованиях, маркетинговых, консультационных и
                    прочих услугах.</p>
                </th>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.current_act.type === 2" class="flex-start-column gap-2r">
            <table class="m-table-act" id="price2">
              <tr>
                <th style="width: 2%">№ п/п</th>
                <th style="width: 9%">Код затрат</th>
                <th style="width: 11%">Месторождение № скважин</th>
                <th style="width: 9%">Код ресурса</th>
                <th style="width: 9%">СПП, ВЗ</th>
                <th style="width: 9%">МВЗ</th>
                <th style="width: 19%">Наименование работ</th>
                <th style="width: 5%">Ед.изм.</th>
                <th style="width: 6.5%">Кол-во</th>
                <th style="width: 8%">Цена, тенге</th>
                <th style="width: 10%">Сумма, тенге</th>
                <th style="width: 11.5%">Примечание</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in current_act.rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <select v-model="row.cost_code" class="m-input-cell required-input">
                    <option value="Отсутствует">Код затрат</option>
                    <option v-for="cost_item in cost_list" :key="cost_item.id" :value="cost_item.code">
                      {{ cost_item.code }}
                    </option>
                  </select>
                </td>
                <td>
                  <input v-model="row.mvz_name" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.source_code" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <input v-model="row.vz_code" class="m-input-cell required-cell"/>
                </td>
                <td>
                  <select v-model="row.mvz_code" class="m-input-cell">
                    <option value="Отсутствует">Код МВЗ</option>
                    <option v-for="mvz_item in mvz_list" :key="mvz_item.id" :value="mvz_item.code">
                      {{ mvz_item.code }}
                    </option>
                  </select>
                </td>
                <td>
                  <input v-model="row.work_name" class="m-input-cell required-cell"/>
                </td>
                <td><input v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                <td>
                  <input v-model="row.count" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <input v-model="row.unit_price" min="0" type="number" class="m-input-cell"
                         v-on:change="auto_calc()"/>
                </td>
                <td>
                  <span class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(row.count * row.unit_price) }}
                  </span>
                </td>
                <td><input v-model="row.research_report" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="12">
                  <button @click="add_row" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td style="height: 35px" colspan="2">
                  <span>Итого</span>
                </td>
                <td v-for="i in [3,4,5,6,7,8,9,10,11,12]" :key="i" style="height: 35px">
                  <span v-if="i === 8" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="height: 35px" colspan="2">
                  <span>Сумма НДС</span>
                </td>
                <td v-for="i in [3,4,5,6,7,8,9,10,11,12]" :key="i" style="height: 35px">
                  <input v-if="i === 8" v-model="current_act.nds" min="0" class="m-input-cell" v-on:change="auto_calc(true)"/>
                </td>
              </tr>
              <tr>
                <td style="height: 35px" colspan="2">
                  <span>Итого c НДС</span>
                </td>
                <td v-for="i in [3,4,5,6,7,8,9,10,11,12]" :key="i" style="height: 35px">
                  <span v-if="i === 8" class="m-input-cell" style="background: inherit">
                    {{ prettyPrice(current_act.total_with_nds) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 4 && this.current_act.type === 2" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Акт приемки выполненных работ №{{ this.current_act.number }}</h4>
              <h4>за {{ this.current_act.act_month }} месяц {{ this.current_act.act_date.split('-')[0] }} г.</h4>
              <input class="input-act-params text-center" style="width: 500px !important; margin-top: 1rem; height: 1rem !important;" placeholder="Введите наименование" v-model="current_act.dks_name">
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <input class="input-act-params" style="height: inherit" placeholder="Введите комментарий по актуальности цен" v-model="current_act.price_comment">
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование объекта" v-model="current_act.object_name_short">
            </div>
            <table class="m-table-act" id="price42" style="border: none !important;">
              <tr>
                <th rowspan="3" style="">№ п/п</th>
                <th rowspan="3" style="">Шифр норм, код ресурса</th>
                <th rowspan="3" style="">Наименование работ</th>
                <th rowspan="3" style="">Единица измерения</th>
                <th rowspan="3" style="">Количество</th>
                <th colspan="2" style="">Стоимость единицы, тенге</th>
                <th colspan="3" style="">Общая стоимость, тенге</th>
                <th rowspan="2" style="">Накладные расходы, тенге</th>
                <th rowspan="3" style="">Всего стоимость с НР и СП, тенге</th>
              </tr>
              <tr>
                <th>Всего</th>
                <th>эксплуатация машин</th>
                <th>Всего</th>
                <th>эксплуатация машин</th>
                <th>материалы</th>
              </tr>
              <tr>
                <th>зарплата рабочих- стоителей</th>
                <th>в т.ч. зарплата машинистов</th>
                <th>зарплата рабочих- стоителей</th>
                <th>в т.ч. зарплата машинистов</th>
                <th>оборудование, мебель, инвентарь</th>
                <th>Сметная прибыль, тенге</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="i">{{ i }}</td>
              </tr>
              <tbody v-for="(row, index) in current_act.rows_accept" :key="index">
              <tr v-if="row.type === 'Пустая строка'">
                <td colspan="12" style="height: 35px"></td>
              </tr>
              <tr v-else-if="row.type === 'Отдел/раздел'">
                <td colspan="12"><input v-model="row.work_name" placeholder="Введите полное наименование отдела/раздела" class="m-input-cell"/></td>
              </tr>
              <tr v-else-if="row.type === 'Одна строка'">
                <td></td>
                <td></td>
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input v-model="row.measure_unit" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_material" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.overheads" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.cost_total" class="m-input-cell"/></td>
              </tr>
              <tr v-else-if="row.type === 'Одна строка - объединенная'">
                <td></td>
                <td colspan="2"><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input v-model="row.measure_unit" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_material" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.overheads" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.cost_total" class="m-input-cell"/></td>
              </tr>
              <tr v-if="row.type === 'Двойная строка'">
                <td rowspan="2">{{ row.serial_number }}</td>
                <td rowspan="2"><textarea v-model="row.source_code" class="m-textarea-cell"></textarea></td>
                <td rowspan="2"><textarea v-model="row.work_name" class="m-textarea-cell"></textarea></td>
                <td rowspan="2"><textarea v-model="row.measure_unit" class="m-textarea-cell"></textarea></td>
                <td rowspan="2"><input type="number" v-model="row.count" class="m-input-cell-big"></td>
                <td><input type="number" v-model="row.unit_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_material" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.overheads" class="m-input-cell"/></td>
                <td rowspan="2"><input type="number" v-model="row.cost_total" class="m-input-cell-big"></td>
              </tr>
              <tr v-if="row.type === 'Двойная строка'">
                <td><input type="number" v-model="row.unit_salary" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_salary_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_salary" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_salary_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_furniture" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.estimated_profit" class="m-input-cell"/></td>
              </tr>
              <tr v-if="row.type === 'Двойная строка - итого'">
                <td rowspan="2"></td>
                <td rowspan="2" colspan="2"><textarea v-model="row.work_name" class="m-textarea-cell"></textarea></td>
                <td rowspan="2"><textarea v-model="row.measure_unit" class="m-textarea-cell"></textarea></td>
                <td rowspan="2"><input type="number" v-model="row.count" class="m-input-cell-big"></td>
                <td><input type="number" v-model="row.unit_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_all" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_material" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.overheads" class="m-input-cell"/></td>
                <td rowspan="2"><input type="number" v-model="row.cost_total" class="m-input-cell-big"></td>
              </tr>
              <tr v-if="row.type === 'Двойная строка - итого'">
                <td><input type="number" v-model="row.unit_salary" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.unit_salary_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_salary" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_salary_car" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_furniture" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.estimated_profit" class="m-input-cell"/></td>
              </tr>
              </tbody>
              <tr>
                <td colspan="12" style="border: none !important;">
                  <button @click="showAddRowAcceptModal" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_accept" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                  <modal name="add-row-accept-modal" :height="350">
                    <h3 class="modal-title" style="padding: 1rem">Выберите тип и количество строк</h3>
                    <div class="modal-inner-short" style="text-align: left; width: 100%">
                      <div class="modal-info" style="width: inherit; display: flex; justify-content: center; flex-direction: column; align-items: center">
                        <select class="input-field-default" id="row-accept-type"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                v-on:change="change_row_accept_type()">
                          <option value="" selected>Выберите тип строки*</option>
                          <option value="Пустая строка">Пустая строка</option>
                          <option value="Отдел/раздел">Отдел/раздел</option>
                          <option value="Одна строка">Одна строка</option>
                          <option value="Одна строка - объединенная">Одна строка - объединенная</option>
                          <option value="Двойная строка">Двойная строка</option>
                          <option value="Двойная строка - итого">Двойная строка - итого</option>
                        </select>
                        <label style="font-size: 15px">Количество строк</label>
                        <input class="input-field-default" style="margin-left: 15%; margin-right: 15%; width: 70%" type="number" placeholder="Количество строк" min="1" v-model="row_accept_count">
                      </div>
                      <div style="position: absolute; bottom: 0; width: 100%; padding: 1rem">
                        <button class="btn-success input-field-default" style="border-radius: 5px;" type="button"
                                v-if="this.row_accept_type !== '' && this.row_accept_count !== ''" @click="add_row_accept">Добавить строку
                        </button>
                      </div>
                    </div>
                  </modal>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 5 && this.current_act.type === 2" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Справка</h4>
              <h4>о стоимости выполненных строительных работ и затрат</h4>
              <h4>(по ресурсному методу)</h4>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование" v-model="current_act.dks_cert_name">
              <input class="input-act-params" style="height: inherit" placeholder="Введите адресс объекта" v-model="current_act.object_address">
              <input class="input-act-params" style="height: inherit" type="number" placeholder="Введите ставку НДС" @change="auto_calc2" v-model="nds_val">

            </div>
            <table class="m-table-act" id="price52" style="">
              <tr>
                <th colspan="4">Код заказчика</th>
                <th colspan="2">Код подрядчика</th>
                <th colspan="2">Договор</th>
                <th colspan="3">Источник финансирования</th>
                <th colspan="2">Организационно-правовая форма</th>
              </tr>
              <tr>
                <th>код учереждения банка</th>
                <th colspan="3">№ счета</th>
                <th>код учереждения банка</th>
                <th>№ счета</th>
                <th>номер</th>
                <th>дата</th>
                <th>наименование</th>
                <th colspan="2">код</th>
                <th>наименование</th>
                <th>код</th>
              </tr>
              <tr>
                <td><input v-model="current_act.customer_bank_code" class="m-input-cell"/></td>
                <td colspan="3"><input v-model="current_act.customer_account_number" class="m-input-cell"/></td>
                <td><input v-model="current_act.impl_bank_code" class="m-input-cell"/></td>
                <td><input v-model="current_act.impl_account_number" class="m-input-cell"/></td>
                <td><input v-model="current_act.contract_number" class="m-input-cell"/></td>
                <td><input v-model="current_act.contract_date" class="m-input-cell"/></td>
                <td><input v-model="current_act.finance_source" class="m-input-cell"/></td>
                <td colspan="2"><input v-model="current_act.finance_code" class="m-input-cell"/></td>
                <td><input v-model="current_act.org_form_name" class="m-input-cell"/></td>
                <td><input v-model="current_act.org_form_code" class="m-input-cell"/></td>
              </tr>
              <tr>
                <th rowspan="4">Наименование пусковых, комплексов, объектов</th>
                <th colspan="10">Стоимость выполненных работ в тыс.тенге</th>
                <th rowspan="4">НДС</th>
                <th rowspan="4">всего к оплате с НДС</th>
              </tr>
              <tr>
                <th rowspan="3">с начала года по отчетный месяц включительно с НДС</th>
                <th rowspan="3">с начала строительства по отчетный месяц включительно без НДС</th>
                <th rowspan="3">Общая стоимость договора на без НДС</th>
                <th rowspan="3">в отчетном месяце (за {{ current_act.act_month }}) без НДС</th>
                <th colspan="6">из графы 1</th>
              </tr>
              <tr>
                <th rowspan="2">Строительно монтажные работы по смете</th>
                <th colspan="2">из них</th>
                <th rowspan="2">стоимость прочих затрат, не входящих в состав СМР по смете 2021г.</th>
                <th colspan="2">дополнительные затраты</th>
              </tr>
              <tr>
                <th>в отчетном месяце</th>
                <th>по монтажу оборудования</th>
                <th>на приобретение материалов</th>
                <th>другие дополнительные расходы</th>
              </tr>
              <tr>
                <td>A</td>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in current_act.rows_cert" :key="index">
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.from_beg_year" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.from_beg_construction" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.contract_total" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.constr_install" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.constr_install_month" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.install_furniture" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.other_expenses" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.materials_purchase" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.additional_costs" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.nds" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td>{{ row.total_with_nds }}</td>
              </tr>
              <tr>
                <td colspan="13">
                  <button @click="add_row_cert" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_cert" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td>Итого</td>
                <td>{{ prettyPrice(current_act.total_from_beg_year) }}</td>
                <td>{{ prettyPrice(current_act.total_from_beg_construction) }}</td>
                <td>{{ prettyPrice(current_act.total_contract_total) }}</td>
                <td>{{ prettyPrice(current_act.total_current_month) }}</td>
                <td v-for="i in [5,6,7,8,9,10]" :key="i"></td>
                <td>{{ prettyPrice(current_act.total_nds) }}</td>
                <td>{{ prettyPrice(current_act.total_twn) }}</td>
              </tr>
              <tr>
                <td>НДС</td>
                <td></td>
                <td><input type="number" v-model="current_act.nds_from_beg_construction" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="current_act.nds_contract_total" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="current_act.nds_current_month" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td v-for="i in [5,6,7,8,9,10,11,12]" :key="i"></td>
              </tr>
              <tr>
                <td>Итого с НДС</td>
                <td></td>
                <td>{{ prettyPrice(current_act.twn_from_beg_construction) }}</td>
                <td>{{ prettyPrice(current_act.twn_contract_total) }}</td>
                <td>{{ prettyPrice(current_act.twn_current_month) }}</td>
                <td v-for="i in [5,6,7,8,9,10,11,12]" :key="i"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>

import router from "../router";

export default {
  name: 'EditActSteps',
  data() {
    return {
      curr_module: 1,
      nds_size: 0,
      // ручной ввод сумм (флаг договора): true — суммы акта не пересчитываются по строкам
      totals_touched: false,
      last_mismatch_message: '',
      all_steps: [
        {
          name: 'Параметры',
          instruction: 'На данном шаге введите основные параметры акта, формы в дальнейших шагах будут построены в зависимости от выбранных Вами параметров',
          instruction_ks: 'На данном шаге введите основные параметры КС, формы в дальнейших шагах будут построены в зависимости от выбранных Вами параметров',
        },
        {
          name: 'Приложения',
          instruction: 'На данном шаге прикрепите все дополнительные файлы (документы / фотографии), необходимые для успешного согласования акта выполненных работ и услуг',
          instruction_ks: 'На данном шаге прикрепите все дополнительные файлы (документы / фотографии), необходимые для успешного согласования КС',
        },
        {
          name: 'Таблица',
          instruction: 'На данном шаге введите основные табличные данные по акту выполненных работ и услуг, учтите, что некоторые поля расчитываются автоматически',
          instruction_ks: 'На данном шаге введите основные табличные данные по КС, учтите, что некоторые поля расчитываются автоматически',
        },
        {
          name: 'Акт приемки',
          instruction: 'На данном шаге введите данные по акту приемки выполненных работ ДКС, учтите, что некоторые поля расчитываются автоматически',
        },
        {
          name: 'Справка',
          instruction: 'На данном шаге введите данные по справке актов ДКС, учтите, что некоторые поля расчитываются автоматически',
        }
      ],
      months_list: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь"
      ],
      contracts: [],
      cost_list: [],
      mvz_list: [],
      row_date_type: '',
      // тип добавляемой строки стандартного акта: 'row' — строка, 'header' — заголовок группы строк
      row_kind: 'row',
      row_accept_type: '',
      row_accept_count: 1,
      curr_serial: 1,
      nds_val: 16.0,
      double_files: [],
      current_act: {
        uploading: false,
        object_name_short: '',
        object_address: '',
        dks_name: '',
        dks_cert_name: '',
        price_comment: '',
        customer_bank_code: '',
        customer_account_number: '',
        impl_bank_code: '',
        impl_account_number: '',
        contract_number: '',
        contract_date: '',
        finance_source: '',
        finance_code: '',
        org_form_name: '',
        org_form_code: '',
        type: 1,
        number: '',
        act_date: '',
        name: '',
        contract: {
          id: '',
        },
        double_files: [],
        object_name: '',
        act_month: '',
        global_mvz: '',
        global_work: '',
        total: 0.0,
        nds: 0.0,
        total_with_nds: 0.0,
        rows: [],
        rows_accept: [],
        rows_cert: []
      }
    };
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    this.nds_size = user['nds_size'];
    // кэш user в localStorage живёт с момента логина — освежаем ставку НДС с бэка
    this.$store.dispatch('getMe').then((response) => {
      this.nds_size = response.data['nds_size'];
      localStorage.setItem('user', JSON.stringify(response.data));
    }).catch(() => {});
  },
  computed: {
    // флаг договора «Ручной ввод сумм» действует только для стандартного акта
    manual_totals: function () {
      if (this.current_act.type !== 1 || !this.current_act.contract) {
        return false;
      }
      // договор в форме можно сменить (select меняет только contract.id) — флаг берём из актуального списка договоров,
      // вложенный снимок договора — запасной вариант, пока список не загрузился
      let contract = this.contracts.find(c => c.id === this.current_act.contract.id);
      return !!(contract ? contract.editable_totals : this.current_act.contract.editable_totals);
    },
    all_required_exist: function () {
      if (this.curr_module === 1 && this.current_act.type !== 2) {
        if (this.current_act.number !== '' &&
            this.current_act.name !== '' &&
            this.current_act.act_date !== '' &&
            this.current_act.contract.id !== '') {
          return true;
        } else {
          return false;
        }
      } else if (this.curr_module === 1) {
        if (this.current_act.number !== '' &&
            this.current_act.name !== '' &&
            this.current_act.act_date !== '' &&
            this.current_act.contract.id !== '' &&
            this.current_act.object_name !== '' &&
            this.current_act.act_month !== '') {
          return true;
        } else {
          return false;
        }
      } else if (this.curr_module === 3) {
        if (this.current_act.rows.length < 1) {
          return false;
        } else if (this.current_act.type === 1 && !this.current_act.rows.some(r => !r.is_header)) {
          // одних заголовков недостаточно — нужна хотя бы одна строка акта
          return false;
        } else {
          if (this.current_act.type > 4) {
            return true;
          }
          for (let i = 0; i < this.current_act.rows.length; i++) {
            let row = this.current_act.rows[i];
            if (row.is_header) {
              if (String(row.work_name || '').trim() === '') {
                return false;
              }
              continue;
            }
            if (this.current_act.type !== 2) {
              if (row.work_name === '' ||
                  row.measure_unit === '' ||
                  row.double_date && row.start_date === '' ||
                  row.double_date && row.end_date === '' ||
                  !row.double_date && row.row_date === '') {
                return false;
              }
            } else {
              if (row.work_name === '' ||
                  row.mvz_name === '' ||
                  row.measure_unit === '') {
                return false;
              }
            }
          }
        }
      }
      return true;
    },
  },
  created() {
    this.getMyContracts();
    this.getCostList();
    this.getMVZList();
    this.getActDetail();
  },
  watch: {
    // переключили тип добавляемой строки — тип даты выбирается заново
    row_kind() {
      this.row_date_type = '';
    },
    // выключили ручной ввод (сменили договор / тип акта) — возвращаемся к пересчёту по строкам
    manual_totals(value) {
      if (!value) {
        this.totals_touched = false;
        this.clear_row_overrides();
        this.auto_calc();
      }
    },
  },
  methods: {
    showDoubleImageModal(index) {
      this.$modal.show("double-modal-" + index);
    },
    getActDetail() {
      this.$store.dispatch("getActDetail", this.$route.params.id).then((response) => {
        this.current_act = response.data;
        if (this.current_act.type === 'Стандартный (458-562)') {
          this.current_act.type = 1;
        } else if (this.current_act.type === 'ДКС') {
          this.current_act.type = 2;
        } else if (this.current_act.type === 'ДБиКРС') {
          this.current_act.type = 3;
        } else if (this.current_act.type === 'Обучение персонала') {
          this.current_act.type = 4;
        } else if (this.current_act.type === 'КС проживание') {
          this.current_act.type = 5;
        } else {
          this.current_act.type = 6;
        }
        this.current_act['double_files'] = [];
        // сохранённые вручную суммы не должны затираться пересчётом по строкам
        this.totals_touched = this.manual_totals;
        if (this.manual_totals) {
          for (let i = 0; i < this.current_act.rows.length; i++) {
            let row = this.current_act.rows[i];
            if (this.row_mismatch(row)) {
              this.$set(row, 'total_manual', true);
            }
            if (row.is_header && this.header_count_mismatch(row)) {
              this.$set(row, 'count_manual', true);
            }
          }
        }
        if (this.current_act.type !== 2) {
          this.all_steps.pop();
          this.all_steps.pop();
        } else {
          this.curr_serial = this.current_act.curr_serial + 1;
        }
      });
    },
    toFixedTruncFloat2(figure) {
      return parseFloat((parseInt(figure * 1000 / 10) / 100.0).toFixed(2));
    },
    toFixedFloat2(figure) {
      return parseFloat(parseFloat(figure).toFixed(2));
    },
    isPartitive2(value) {
      let partitive_value = value.toString().replace(',', '.').split('.');
      if (partitive_value.length > 1) {
        if (partitive_value[1].length > 2) {
          return true;
        }
      }
      return false;
    },
    // сквозная нумерация: заголовки без номера, строки нумеруются подряд по всему акту
    row_display_number(index) {
      let number = 0;
      for (let i = 0; i <= index && i < this.current_act.rows.length; i++) {
        if (!this.current_act.rows[i].is_header) {
          number += 1;
        }
      }
      return number;
    },
    // заголовок группы строк: расчётные количество и стоимость — суммы строк ниже до следующего заголовка
    header_expected(header) {
      let start = this.current_act.rows.indexOf(header);
      let count = 0.0;
      let total = 0.0;
      if (start < 0) {
        return {count: 0.0, total: 0.0};
      }
      for (let i = start + 1; i < this.current_act.rows.length; i++) {
        let row = this.current_act.rows[i];
        if (row.is_header) {
          break;
        }
        let row_count = parseFloat(row.count);
        let row_total = parseFloat(row.total);
        count += isNaN(row_count) ? 0 : row_count;
        total += isNaN(row_total) ? 0 : row_total;
      }
      return {count: parseFloat(count.toFixed(3)), total: this.toFixedFloat2(total)};
    },
    header_count_mismatch(row) {
      if (!this.manual_totals || !row.is_header) {
        return false;
      }
      let count = parseFloat(row.count);
      if (isNaN(count)) {
        return true;
      }
      return Math.abs(parseFloat(count.toFixed(3)) - this.header_expected(row).count) > 0.0005;
    },
    manual_header_count_changed(row) {
      let value = parseFloat(String(row.count).replace(',', '.'));
      if (isNaN(value) || value < 0) {
        value = 0.0;
      }
      row.count = parseFloat(value.toFixed(3));
      this.$set(row, 'count_manual', true);
      this.auto_calc();
    },
    // пересчёт заголовков по строкам (кроме введённых вручную при флаге договора)
    calc_headers() {
      for (let i = 0; i < this.current_act.rows.length; i++) {
        let row = this.current_act.rows[i];
        if (!row.is_header) {
          continue;
        }
        let expected = this.header_expected(row);
        if (!(this.manual_totals && row.count_manual)) {
          row.count = expected.count;
        }
        if (!(this.manual_totals && row.total_manual)) {
          row.total = expected.total;
        }
      }
    },
    // ручной ввод стоимости строки (флаг договора): расчётное значение и признак расхождения
    row_expected_total(row) {
      if (row.is_header) {
        return this.header_expected(row).total;
      }
      let count = parseFloat(row.count);
      let unit_price = parseFloat(row.unit_price);
      let reason_cost = parseFloat(row.reason_cost);
      return this.toFixedFloat2((isNaN(count) ? 0 : count) * (isNaN(unit_price) ? 0 : unit_price)
          - (isNaN(reason_cost) ? 0 : reason_cost));
    },
    row_mismatch(row) {
      if (!this.manual_totals) {
        return false;
      }
      let total = parseFloat(row.total);
      if (isNaN(total)) {
        return true;
      }
      return Math.abs(this.toFixedFloat2(total) - this.row_expected_total(row)) > 0.005;
    },
    manual_row_total_changed(row) {
      let value = parseFloat(String(row.total).replace(',', '.'));
      if (isNaN(value) || value < 0) {
        value = 0.0;
      }
      row.total = this.toFixedFloat2(value);
      this.$set(row, 'total_manual', true);
      this.auto_calc();
    },
    // информационное сообщение о расхождении калькуляции по строкам (не блокирует сохранение)
    notify_row_mismatches() {
      let mismatches = [];
      for (let i = 0; i < this.current_act.rows.length; i++) {
        let row = this.current_act.rows[i];
        if (row.is_header) {
          let expected = this.header_expected(row);
          if (this.header_count_mismatch(row)) {
            mismatches.push('заголовок «' + row.work_name + '» — количество: введено ' + parseFloat(parseFloat(row.count).toFixed(3)) +
                ', по строкам ' + expected.count);
          }
          if (this.row_mismatch(row)) {
            mismatches.push('заголовок «' + row.work_name + '» — стоимость: введено ' + this.prettyPrice(row.total) +
                ', по строкам ' + this.prettyPrice(expected.total));
          }
          continue;
        }
        if (this.row_mismatch(row)) {
          mismatches.push('№' + this.row_display_number(i) + ': введено ' + this.prettyPrice(row.total) +
              ', по расчёту ' + this.prettyPrice(this.row_expected_total(row)));
        }
      }
      let message = mismatches.length
          ? 'Калькуляция не сходится (количество × цена ≠ стоимость, суммы по заголовкам) по строкам: ' + mismatches.join('; ') +
            '. Это информационное сообщение — акт можно сохранить с введёнными значениями.'
          : '';
      // одно и то же расхождение не повторяем при каждом изменении строк
      if (message && message !== this.last_mismatch_message) {
        this.$store.dispatch('addNotification', {
          type: 'warning',
          message: message,
        });
      }
      this.last_mismatch_message = message;
    },
    // ручной ввод сумм: нормализуем введённое, «Всего» пересчитываем от «Итого» + НДС,
    // если менялось само «Всего» — оставляем как ввёл пользователь
    manual_totals_changed(field) {
      let value = parseFloat(String(this.current_act[field]).replace(',', '.'));
      if (isNaN(value) || value < 0) {
        value = 0.0;
      }
      this.current_act[field] = this.toFixedFloat2(value);
      if (field !== 'total_with_nds') {
        this.current_act.total_with_nds = this.toFixedFloat2(
            this.toFixedFloat2(this.current_act.total) + this.toFixedFloat2(this.current_act.nds));
      }
      this.totals_touched = true;
    },
    recalc_totals_from_rows() {
      this.totals_touched = false;
      this.clear_row_overrides();
      this.auto_calc();
    },
    clear_row_overrides() {
      for (let i = 0; i < this.current_act.rows.length; i++) {
        if (this.current_act.rows[i].total_manual) {
          this.$set(this.current_act.rows[i], 'total_manual', false);
        }
        if (this.current_act.rows[i].count_manual) {
          this.$set(this.current_act.rows[i], 'count_manual', false);
        }
      }
    },
    auto_calc(nds_changed = false) {
      let total = 0.0;
      let rounding_flag = false;
      let negative_flag = false;
      for (let i = 0; i < this.current_act.rows.length; i++) {
        let row = this.current_act.rows[i];
        if (row.count === '') {
          row.count = 0.0;
        }
        if (row.unit_price === '') {
          row.unit_price = 0.0;
        }
        if (row.reason_cost === '') {
          row.reason_cost = 0.0;
        }

        row.count = parseFloat(row.count);
        rounding_flag = rounding_flag || this.isPartitive2(row.unit_price);
        row.unit_price = this.toFixedFloat2(row.unit_price);

        rounding_flag = rounding_flag || this.isPartitive2(row.reason_cost);
        row.reason_cost = this.toFixedFloat2(row.reason_cost);

        if (row.unit_price < 0) {
          row.unit_price = 0.0;
          negative_flag = true;
        }
        if (row.count < 0) {
          row.count = 0.0;
          negative_flag = true;
        }
        if (row.reason_cost < 0 || row.unit_price * row.count - row.reason_cost < 0) {
          row.reason_cost = 0.0;
          negative_flag = true;
        }

        if (row.is_header) {
          // заголовок: количество/стоимость считаются ниже по строкам группы, в «Итого» не входит
          continue;
        }
        // rounding_flag = rounding_flag || this.isPartitive2(row.count * row.unit_price);
        if (this.manual_totals && row.total_manual) {
          // стоимость строки введена вручную — оставляем как есть
          row.total = this.toFixedFloat2(row.total);
          if (isNaN(row.total) || row.total < 0) {
            row.total = 0.0;
          }
        } else {
          row.total = this.toFixedFloat2(row.count * row.unit_price - row.reason_cost);
        }

        total += row.total;
      }

      this.calc_headers();

      if (this.manual_totals) {
        this.notify_row_mismatches();
      }

      if (this.manual_totals && this.totals_touched) {
        // суммы введены вручную — по строкам не пересчитываем
        this.notify_calc_flags(rounding_flag, negative_flag);
        return;
      }

      if (this.current_act.nds === '') {
        this.current_act.nds = 0.0;
      }
      if (!nds_changed) {
        if (this.nds_size > 0) {
          this.current_act.nds = total * (this.nds_size / 100);
        }
      }

      rounding_flag = rounding_flag || this.isPartitive2(this.current_act.nds);
      this.current_act.nds = this.toFixedFloat2(this.current_act.nds);
      if (this.current_act.nds < 0) {
        this.current_act.nds = 0.0;
        negative_flag = true;
      }

      this.current_act.total = total;
      this.current_act.total_with_nds = this.toFixedFloat2(this.current_act.total + this.current_act.nds);
      this.notify_calc_flags(rounding_flag, negative_flag);
    },
    notify_calc_flags(rounding_flag, negative_flag) {

      if (rounding_flag && negative_flag) {
        // alert('1. Значения в числовых ячейках не могут быть < 0; 2. Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Значения не могут быть меньше нуля. Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (rounding_flag) {
        // alert('Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (negative_flag) {
        // alert('Значения в числовых ячейках не могут быть отрицательными значениями');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Значения в числовых ячейках не могут быть отрицательными значениями',
          })
      }
    },
    auto_calc2() {
      let total_from_beg_year = 0.0;
      let total_from_beg_construction = 0.0;
      let total_contract_total = 0.0;
      let total_current_month = 0.0;
      let total_nds = 0.0;
      let total_twn = 0.0;

      let rounding_flag = false;
      let negative_flag = false;
      for (let i = 0; i < this.current_act.rows_cert.length; i++) {
        let row = this.current_act.rows_cert[i];
        let from_beg_year = 0.0;
        let from_beg_construction = 0.0;
        let contract_total = 0.0;
        let current_month = 0.0;

        if (row.from_beg_year !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.from_beg_year);
          row.from_beg_year = this.toFixedFloat2(row.from_beg_year);
          if (row.from_beg_year < 0) {
            row.from_beg_year = 0.0;
            negative_flag = true;
          }
          from_beg_year = row.from_beg_year;
        }
        if (row.from_beg_construction !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.from_beg_construction);
          row.from_beg_construction = this.toFixedFloat2(row.from_beg_construction);
          if (row.from_beg_construction < 0) {
            row.from_beg_construction = 0.0;
            negative_flag = true;
          }
          from_beg_construction = row.from_beg_construction;
        }
        if (row.contract_total !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.contract_total);
          row.contract_total = this.toFixedFloat2(row.contract_total);
          if (row.contract_total < 0) {
            row.contract_total = 0.0;
            negative_flag = true;
          }
          contract_total = row.contract_total;
        }
        if (row.current_month !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.current_month);
          row.current_month = this.toFixedFloat2(row.current_month);
          if (row.current_month < 0) {
            row.current_month = 0.0;
            negative_flag = true;
          }
          current_month = row.current_month;
        }

        // row.nds = this.toFixedFloat2(current_month * (this.nds_val / 100.0));
        row.total_with_nds = this.toFixedFloat2(row.nds) + this.toFixedFloat2(current_month);

        total_from_beg_year += from_beg_year;
        total_from_beg_construction += from_beg_construction;
        total_contract_total += contract_total;
        total_current_month += current_month;
        total_nds += this.toFixedFloat2(row.nds);
        total_twn += this.toFixedFloat2(row.total_with_nds);
      }

      this.current_act.total_from_beg_year = total_from_beg_year;
      this.current_act.total_from_beg_construction = total_from_beg_construction;
      this.current_act.total_contract_total = total_contract_total;
      this.current_act.total_current_month = total_current_month;
      this.current_act.total_nds = total_nds;
      this.current_act.total_twn = total_twn;

      // this.current_act.nds_from_beg_construction = this.toFixedFloat2(this.current_act.total_from_beg_construction * (this.nds_val / 100.0));
      // this.current_act.nds_contract_total = this.toFixedFloat2(this.current_act.total_contract_total * (this.nds_val / 100.0));
      // this.current_act.nds_current_month = this.toFixedFloat2(this.current_act.total_current_month * (this.nds_val / 100.0));

      this.current_act.twn_from_beg_construction = this.toFixedFloat2(this.current_act.total_from_beg_construction) + this.toFixedFloat2(this.current_act.nds_from_beg_construction);
      this.current_act.twn_contract_total = this.toFixedFloat2(this.current_act.total_contract_total) + this.toFixedFloat2(this.current_act.nds_contract_total);
      this.current_act.twn_current_month = this.toFixedFloat2(this.current_act.total_current_month) + this.toFixedFloat2(this.current_act.nds_current_month);

      if (rounding_flag && negative_flag) {
        // alert('1. Значения в числовых ячейках не могут быть < 0; 2. Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Значения не могут быть меньше нуля. Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (rounding_flag) {
        // alert('Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (negative_flag) {
        // alert('Значения в числовых ячейках не могут быть отрицательными значениями');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Значения в числовых ячейках не могут быть отрицательными значениями',
          })
      }
    },
    reuploadVl1() {
      // const file = this.$refs.file.files[0];
      let fileName = document.getElementById("input-field-multiple").value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

      console.log(fileName);
      console.log(idxDot);
      console.log(extFile);
      if (!(extFile === "png" || extFile === "pdf" || extFile === "xls" || extFile === "xlsx" || extFile === "jpg")) {
        this.$modal.show("file-modal-multiple");
        this.file = null;
      } else {
        this.current_act.uploading = true;
      }
    },
    reuploadVl_d1(index) {
      // const file = this.$refs['file_d1_' + index].files[0];
      let fileName = document.getElementById("input-field-d1-" + index).value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

      if (!(extFile === "png" || extFile === "jpg")) {
        this.$modal.show("file-modal-d1-" + index);
        this.file = null;
      } else {
        this.double_files[index].uploading_d1 = true;
      }
    },
    reuploadVl_d2(index) {
      // const file = this.$refs['file_d2_' + index].files[0];
      let fileName = document.getElementById("input-field-d2-" + index).value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

      if (!(extFile === "png" || extFile === "jpg")) {
        this.$modal.show("file-modal-d2-" + index);
        this.file = null;
      } else {
        this.double_files[index].uploading_d2 = true;
      }
    },
    closeModalMultuple() {
      this.$modal.hide("file-modal-multiple");
    },
    closeModalD1(index) {
      this.$modal.hide("file-modal-d1-" + index);
    },
    closeModalD2(index) {
      this.$modal.hide("file-modal-d2-" + index);
    },
    add_double_file() {
      console.log('add_double_file');
      let a = {
        uploading_d1: false,
        uploading_d2: false
      };
      this.double_files.push(a);

    },
    change_row_date_type() {
      let row_date_type_element = document.getElementById('row-date-type');
      this.row_date_type = row_date_type_element.value;
    },
    change_row_date_type_4() {
      let row_date_type_element = document.getElementById('row-date-type-4');
      this.row_date_type = row_date_type_element.value;
    },
    change_row_accept_type() {
      let row_accept_type_element = document.getElementById('row-accept-type');
      this.row_accept_type = row_accept_type_element.value;
    },
    add_header_row() {
      this.current_act.rows.push({
        is_header: true,
        cost_code: 'Отсутствует',
        mvz_code: 'Отсутствует',
        source_code: '',
        mvz_name: '',
        iin: '',
        fio: '',
        work_name: '',
        double_date: false,
        start_date: '',
        end_date: '',
        row_date: '',
        research_report: '',
        measure_unit: '',
        count: 0.0,
        unit_price: 0.0,
        taksa: 0.0,
        penalty: 0.0,
        total_service: 0.0,
        nds_service: 0.0,
        marshrut: '',
        podrazdelenie: '',
        blank_number: '',
        total: 0.0,
        reason: '',
        reason_cost: 0.0
      });
      this.row_kind = 'row';
      this.$modal.hide("add-row-modal");
      this.auto_calc();
    },
    add_row() {
      let double_date = true;
      if (this.row_kind === 'header' && this.current_act.type === 1) {
        this.add_header_row();
        return;
      }
      if (this.row_date_type === '' && this.current_act.type !== 2) {
        // alert('Выберите тип даты акта');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Выберите тип даты акта',
          })
        return;
      }
      if (this.row_date_type === '1') {
        double_date = false;
      }
      let row = {
        cost_code: 'Отсутствует',
        vz_code: 'Отсутствует',
        mvz_code: 'Отсутствует',
        source_code: '',
        mvz_name: '',
        work_name: '',
        double_date: double_date,
        start_date: '',
        penalty: 0.0,
        total_service: 0.0,
        nds_service: 0.0,
        marshrut: '',
        podrazdelenie: '',
        blank_number: '',
        end_date: '',
        row_date: '',
        research_report: '',
        measure_unit: 'услуга',
        count: 0.0,
        unit_price: 0.0,
        taksa: 0.0,
        total: 0.0,
        reason: '',
        reason_cost: 0.0
      };
      this.current_act.rows.push(row);
      this.row_date_type = '';
      this.$modal.hide("add-row-modal");
    },
    add_row_cert() {
      if (this.current_act.type !== 2) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка типа акта',
          })
        return;
      }
      let row = {
        work_name: '',
        from_beg_year: '',
        from_beg_construction: '',
        contract_total: '',
        current_month: '',
        constr_install: '',
        constr_install_month: '',
        install_furniture: '',
        other_expenses: '',
        materials_purchase: '',
        additional_costs: '',
        nds: '',
        total_with_nds: ''
      };
      this.current_act.rows_cert.push(row);
    },
    add_row_accept() {
      if (this.row_accept_type === '' || this.current_act.type !== 2) {
        // alert('Выберите тип строки акта');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Выберите тип строки акта',
          })
        return;
      }
      if (this.row_accept_count === '' || this.current_act.type !== 2) {
        // alert('Выберите количество строк');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: 'Выберите количество строк',
          })
        return;
      }


      for (let i=0; i<this.row_accept_count; i++) {
        let serial_i = 0;
        if (this.row_accept_type === 'Двойная строка') {
          serial_i = this.curr_serial;
          this.curr_serial += 1;
        }
        let row = {
          serial_number: serial_i,
          type: this.row_accept_type,

          work_name: '',

          source_code: '',
          measure_unit: '',
          count: '',
          count_percent: false,

          unit_all: '',
          unit_car: '',
          unit_salary: '',
          unit_salary_car: '',

          total_all: '',
          total_car: '',
          total_material: '',
          total_salary: '',
          total_salary_car: '',
          total_furniture: '',

          overheads: '',
          estimated_profit: '',

          cost_total: '',
        };
        this.current_act.rows_accept.push(row);
      }
      this.row_accept_type = '';
      this.row_accept_count = 1;
      this.$modal.hide("add-row-accept-modal");
    },
    rm_row() {
      this.current_act.rows.pop();
      this.auto_calc();
    },
    rm_row_index(index) {
      this.current_act.rows.splice(index, 1);
      this.auto_calc();
    },
    rm_row_cert() {
      this.current_act.rows_cert.pop();
    },
    rm_row_accept() {
      this.current_act.rows_accept.pop();
    },
    getMyContracts() {
      this.$store.dispatch("getMyContracts").then((response) => {
        this.contracts = response.data;
      });
    },
    getCostList() {
      this.$store.dispatch("getCostList").then((response) => {
        this.cost_list = response.data;
      });
    },
    getMVZList() {
      this.$store.dispatch("getMVZList").then((response) => {
        this.mvz_list = response.data;
      });
    },
    showAddRowModal() {
      this.$modal.show("add-row-modal");
    },
    showAddRowAcceptModal() {
      this.$modal.show("add-row-accept-modal");
    },
    prettyPrice(price) {
      if (typeof price == "number") {
        return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      } else {
        return price;
      }
    },
    updateAct() {
      let formData = new FormData();
      formData.append('act_id', this.current_act.id);
      for (let i = 0; i < this.$refs['files_additional'].files.length; i++) {
        let file = this.$refs['files_additional'].files[i];
        formData.append('files_additional-' + i, file);
      }

      for (let i = 0; i < this.double_files.length; i++) {
        let double_file = this.double_files[i];
        if (double_file.uploading_d1 && double_file.uploading_d2) {
          let file_d1 = this.$refs['file_d1_' + i][0].files[0];
          let file_d2 = this.$refs['file_d2_' + i][0].files[0];
          formData.append('file_d1-' + i, file_d1);
          formData.append('file_d2-' + i, file_d2);
        }
      }

      this.current_act.double_files = this.double_files;

      const json = JSON.stringify(this.current_act);

      formData.append('new_act', json);

      this.$store.dispatch('updateAct', formData).then((response) => {
        console.log(response);
        router.push({name: 'actview', params: {id: this.current_act.id}});
      }).catch((error) => {
        // alert(error);
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data.detail,
          })
      });
    },
    curr_class(arg) {
      if (this.curr_module === arg) {
        return 'current';
      } else if (this.curr_module > arg) {
        return 'done';
      }
      return '';
    },
    getLineThroughClass(to_remove) {
      if (to_remove) {
        return 'line-though';
      }
      return '';
    },
    getFilesHiddenClass(curr_mod) {
      console.log('curr_module');
      console.log(curr_mod);
      if (curr_mod !== 2) {
        return 'hidden-element';
      }
      return '';
    },
    prevStep() {
      if (this.curr_module > 1) {
        this.curr_module -= 1;
      }
    },
    nextStep() {
      if (this.current_act.type !== 2) {
        if (this.curr_module < 3) {
          this.curr_module += 1;
        } else {
          this.updateAct();
        }
      } else {
        if (this.curr_module < this.all_steps.length) {
          this.curr_module += 1;
        } else if (this.curr_module === 5) {
          this.updateAct();
        }
      }
    },
    prev_next_btn_class() {
      if (this.curr_module === 1) {
        return 'flex-end';
      } else {
        return 'flex-space-between';
      }
    },
    get_arrow_steps_class() {
      if (this.current_act.type !== 2) {
        return 'arrow-steps';
      } else {
        return 'arrow-steps-short';
      }
    }
  }
}
</script>

<style scoped>
@import "../assets/css/Nunito.css";
@import "../assets/css/josefin.css";

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Nunito", sans-serif;
}

.hidden-element {
  display: none !important;
}

.line-though {
  text-decoration: line-through;
  text-decoration-color: red;
  text-decoration-thickness: 3px
}

.required-cell {
  /*  */
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.m-table-act {
  width: 100%;

  text-align: center;
  font-size: x-small;
  border: 1px solid black;
  border-collapse: collapse;
}

.m-table-act td {
  border: 1px solid black;
  border-collapse: collapse;
}

.m-table-act th {
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  -webkit-transition: all 1s ease-out;
  border: 1px solid black;
  border-collapse: collapse;
}

.input-field-default {
  width: 100%;
  padding: 10px;
  border: 1px solid gray;
  text-align: center;
  font-size: 1rem;
  outline: none;
  margin: 0.5rem 0 1rem;
  border-radius: 10px;
}

.rm_row_btn_small {
  margin: 0.2rem;
  background: rgba(255, 0, 0, 0.76);
  width: 1.5rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.header-row td {
  background: #f3f4f6;
}

.header-name {
  font-weight: bold;
}

.calc-mismatch {
  background: #fff3cd;
  border: 1px solid #f0ad4e;
}

.m-input-cell {
  width: 100%;
  /*border-width: 1px;*/
  height: 35px;
  text-align: center;
}

.m-textarea-cell {
  display: block;
  width: 100%;
  padding: .5rem;
  /*border-width: 1px;*/
  height: 72px;
  text-align: left;
  resize: none;
}

.upload-from-xls {
  padding: 0.3rem 0.7rem 0.3rem 0.7rem;
  background-color: #00aacc;
  color: white;
  border-radius: 5px;
}

.m-input-cell-big {
  display: block;
  width: 100%;
  /*border-width: 1px;*/
  height: 72px;
  text-align: center;
}

.dropzone {
  /*margin-top: 3rem;*/
  height: 250px;
  min-height: 250px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  border: 2px dashed gray;
  outline-offset: 10px;
  background: #d9e3f7;
  color: dimgray;
}

.input-field {
  opacity: 0;
  width: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  cursor: pointer;
}

.dropzone:hover {
  background: lightblue;
  transition: all 300ms ease;
}

.dropzone .call-to-action {
  font-size: 1.5rem;
  text-align: center;
  padding: 70px 0;
}

.call-to-action > div {
  font-size: 1rem;
  padding: 1rem 2rem;
  background: #00aacc;
  max-width: 300px;
  margin: 1rem auto;
  border-radius: 20px;
  color: #fff;
}

.uploaded-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.add_double_file {
  padding: .5rem;
  margin: .5rem;
  background: #23468c;
  color: white;
  border-radius: 10px;
}

.add_row_btn {
  padding: .5rem;
  margin: 1rem;
  background: #0c8;
  width: 2.6rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.rm_row_btn {
  padding: .5rem;
  margin: 1rem;
  background: rgba(255, 0, 0, 0.76);
  width: 2.6rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.modal-inner {
  height: 100%;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}

.modal-inner-short {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

@media (min-width: 2000px) {
  .container {
    width: 1500px;
  }
}

.table-responsive {
  border-radius: 10px;
  overflow-x: hidden;
}

@keyframes wave {
  50% {
    transform: scale(0.9);
  }
}

.input-act-params {
  background: white;
  height: 60px;
  /*border: 1px solid gray;*/
  border-radius: .5rem;
  width: 100% !important;
  padding: 1rem;
}

.selected-items-wrapper {
  width: 300px;
  height: calc(100% - 300px);
  position: absolute;
  top: 300px;
  right: -300px;
  opacity: 0.8;
  padding: 1rem;
  overflow-y: auto;
  color: gray;
}

.selected-items-wrapper::-webkit-scrollbar {
  width: 13px;
  height: 13px;
}

.selected-items-wrapper::-webkit-scrollbar-track {
  border-radius: 15px;
}

.selected-items-wrapper::-webkit-scrollbar-thumb {
  border-radius: 100px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.categories-container {
  width: 100%;
}

.circle-number {
  border-radius: 300px;
  background: #23468c;
  color: #fff;
  float: left;
  font-size: 3rem;
  height: 80px;
  margin-right: 10px;
  margin-top: 5px;
  text-align: center;
  width: 80px;
  font-weight: bold;
  padding-top: 8px;
}

.module-title {
  padding-top: 30px;
}

.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  background: inherit;
}

.wrapper {
  display: table-cell;
  height: 200px;
  vertical-align: middle;
}

a, a:active {
  color: #333;
  text-decoration: none;
}

a:hover {
  color: #999;
}

.arrow-steps .step {
  font-size: 14px;
  text-align: center;
  color: #666;
  cursor: default;
  margin: 0 3px;
  padding: 10px 10px 10px 30px;
  min-width: 325px;
  float: left;
  position: relative;
  background-color: #d9e3f7;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: background-color 0.2s ease;
}

.arrow-steps-short .step {
  font-size: 14px;
  text-align: center;
  color: #666;
  cursor: default;
  margin: 0 3px;
  padding: 10px 10px 10px 30px;
  min-width: 220px;
  float: left;
  position: relative;
  background-color: #d9e3f7;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: background-color 0.2s ease;
}

@media (max-width: 2000px) {
  .arrow-steps .step {
    min-width: 374px !important;
  }

  .arrow-steps-short .step {
    min-width: 220px !important;
  }
}

.arrow-steps .step:after,
.arrow-steps .step:before {
  content: " ";
  position: absolute;
  top: 0;
  right: -17px;
  width: 0;
  height: 0;
  border-top: 19px solid transparent;
  border-bottom: 24px solid transparent;
  border-left: 17px solid #d9e3f7;
  z-index: 2;
  transition: border-color 0.2s ease;
}

.arrow-steps .step:before {
  right: auto;
  left: 0;
  border-left: 17px solid #e4e9f7;
  z-index: 0;
}

.arrow-steps .step:first-child:before {
  border: none;
}

.arrow-steps .step:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.arrow-steps .step span {
  position: relative;
}

.arrow-steps .step span:before {
  opacity: 0;
  content: "✔";
  position: absolute;
  top: -2px;
  left: -20px;
}

.arrow-steps .step.done span:before {
  opacity: 1;
  -webkit-transition: opacity 0.3s ease 0.5s;
  -moz-transition: opacity 0.3s ease 0.5s;
  -ms-transition: opacity 0.3s ease 0.5s;
  transition: opacity 0.3s ease 0.5s;
}

.arrow-steps .step.current {
  color: #fff;
  background-color: #23468c;
}

.arrow-steps .step.current:after {
  border-left: 17px solid #23468c;
}


.arrow-steps-short .step:after,
.arrow-steps-short .step:before {
  content: " ";
  position: absolute;
  top: 0;
  right: -17px;
  width: 0;
  height: 0;
  border-top: 19px solid transparent;
  border-bottom: 24px solid transparent;
  border-left: 17px solid #d9e3f7;
  z-index: 2;
  transition: border-color 0.2s ease;
}

.arrow-steps-short .step:before {
  right: auto;
  left: 0;
  border-left: 17px solid #e4e9f7;
  z-index: 0;
}

.arrow-steps-short .step:first-child:before {
  border: none;
}

.arrow-steps-short .step:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.arrow-steps-short .step span {
  position: relative;
}

.arrow-steps-short .step span:before {
  opacity: 0;
  content: "✔";
  position: absolute;
  top: -2px;
  left: -20px;
}

.arrow-steps-short .step.done span:before {
  opacity: 1;
  -webkit-transition: opacity 0.3s ease 0.5s;
  -moz-transition: opacity 0.3s ease 0.5s;
  -ms-transition: opacity 0.3s ease 0.5s;
  transition: opacity 0.3s ease 0.5s;
}

.arrow-steps-short .step.current {
  color: #fff;
  background-color: #23468c;
}

.arrow-steps-short .step.current:after {
  border-left: 17px solid #23468c;
}

</style>
